var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 3.9375C8.17731 3.9375 7 5.11481 7 6.5625V11.8125H8.75V6.5625C8.75 6.07994 9.14244 5.6875 9.625 5.6875H18.375C18.8576 5.6875 19.25 6.07994 19.25 6.5625V21.4375C19.25 21.9201 18.8576 22.3125 18.375 22.3125H9.625C9.14244 22.3125 8.75 21.9201 8.75 21.4375V16.1875H7V21.4375C7 22.8852 8.17731 24.0625 9.625 24.0625H18.375C19.8227 24.0625 21 22.8852 21 21.4375V6.5625C21 5.11481 19.8227 3.9375 18.375 3.9375H9.625ZM11.3494 10.0616C11.1254 10.0625 10.9022 10.1491 10.7324 10.3206C10.392 10.6636 10.3937 11.2183 10.7367 11.5587L12.3141 13.125H5.6875C5.2045 13.125 4.8125 13.517 4.8125 14C4.8125 14.483 5.2045 14.875 5.6875 14.875H12.3141L10.7367 16.4413C10.3937 16.7821 10.392 17.3356 10.7324 17.6786C10.9035 17.851 11.1275 17.9375 11.3528 17.9375C11.5759 17.9375 11.7995 17.8535 11.9697 17.6837L15.0536 14.6212C15.219 14.4572 15.3125 14.2332 15.3125 14C15.3125 13.7668 15.219 13.5433 15.0536 13.3788L11.9697 10.3163C11.7982 10.1459 11.5734 10.0608 11.3494 10.0616Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignblack);
export default __webpack_public_path__ + "static/media/signblack.bc26adfc2a35319e65ca07ec46cb01d3.svg";
export { ForwardRef as ReactComponent };